import { render, staticRenderFns } from "./ProductWeightSection.vue?vue&type=template&id=1db97d9a&"
import script from "./ProductWeightSection.vue?vue&type=script&lang=js&"
export * from "./ProductWeightSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports